import React from 'react';
import { useWatch } from 'react-hook-form';
import { DateRangeSelector } from '../event-fields/DateRangeSelector';
import { SessionManager } from '../event-fields/SessionManager';

/**
 * Event Date Details Tab Component
 * Handles date and session management
 */
export const EventDateDetailsTab = ({ eventType, dateType, isEdit = false, permissions = {} }) => {
  // Tarih duzenleme: olusturmada herkes; duzenlemede yalnizca admin/operator.
  // Tarih degisikligi backend'de iliskili stok/satis/biletlere otomatik yansir.
  const canEditDate =
    permissions?.crole === 'admin' || permissions?.crole === 'operator';
  const dateDisabled = isEdit && !canEditDate;
  const watchedDateType = useWatch({ name: 'dateType' });
  // Formda yoksa create/edit'ten gelen prop kullan (edit'te bos gorunme bug'i)
  const resolvedDateType = watchedDateType || dateType;

  if (resolvedDateType === 'oneoff') {
    return <DateRangeSelector disabled={dateDisabled} isEdit={isEdit} />;
  }
  if (resolvedDateType === 'session') {
    return <SessionManager disabled={dateDisabled} isEdit={isEdit} />;
  }

  return (
    <span style={{ color: '#b45309' }}>
      Date type missing on this event (dateType). Re-save from Date Details after fixing event
      type, or set dateType to oneoff/session.
    </span>
  );
};
